export const initialAbility = [
  {
    action: 'manage',
    subject: 'all',
  },
  {
    action: 'read',
    subject: 'all',
  },
]

export const _ = undefined
